import { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { FaLock, FaUser } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import '../../assets/styles/profile.screen.css';
import Loader from '../../components/layout/Loader';
import Meta from '../../components/layout/Meta';
import { setCredentials } from '../../slices/authSlice';
import { useProfileMutation } from '../../slices/userApiSlice';

const ProfileScreen = () => {
    const [name, setName] = useState('');
    const [docId, setDocId] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const dispatch = useDispatch();

    const { userInfo } = useSelector((state) => state.auth);

    const [updateProfile, { isLoading: loadingUpdateProfile }] = useProfileMutation();


    useEffect(() => {
        if (userInfo) {
            setName(userInfo.name);
            setEmail(userInfo.email);
            if (userInfo.docId) {
                setDocId(userInfo.docId);
            }
        }
    }, [userInfo, userInfo.name, userInfo.email, userInfo.docId]);

    const submitHandler = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            toast.error('Las contraseñas no coinciden');
        } else {
            try {
                const res = await updateProfile({
                    _id: userInfo._id,
                    name,
                    docId,
                    password,
                }).unwrap();
                dispatch(setCredentials(res));
                toast.success('Perfil Actualizado');
            } catch (err) {
                toast.error(err?.data?.message || err.error);
            }
        }
    };

    return (
        <>
            <Meta title="Perfil de Usuario" />
            <Row className="gy-4 justify-content-center">
                <Col md={6} lg={5}>
                <Card className="profile-card">
                    <Card.Header className="d-flex align-items-center">
                        <FaUser className="me-2" /> Perfil de Usuario
                    </Card.Header>
                    <Card.Body>
                        <Form onSubmit={submitHandler}>
                            <Form.Group controlId="name" className="mb-3">
                                <Form.Label column='lg'>Nombre</Form.Label>
                                <Form.Control
                                    type="name"
                                    placeholder="Ingrese su nombre"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </Form.Group>

                            <Form.Group controlId="docId" className="mb-3">
                                <Form.Label column='lg'>Documento de Identidad</Form.Label>
                                <Form.Control
                                    type="text"
                                    disabled
                                    placeholder="Ingrese el numero de su documento de identidad"
                                    value={docId}
                                    onChange={(e) => setDocId(e.target.value)}
                                />
                            </Form.Group>

                            <Form.Group controlId="email" className="mb-4">
                                <Form.Label column='lg'>Correo</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Ingrese su correo"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </Form.Group>

                            <div className="bg-light p-3 rounded mb-4">
                                <h6 className="d-flex align-items-center mb-3">
                                    <FaLock className="me-2" /> Cambio de Contraseña
                                </h6>
                                <p className="text-muted small mb-3">
                                    Dejar en blanco en caso de no requerir cambiarla.
                                </p>

                                <Form.Group controlId="password" title="password" className="mb-3">
                                    <Form.Label className="small" column='sm'>Nueva Contraseña</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder="Nueva contraseña"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </Form.Group>

                                <Form.Group controlId="confirmPassword" title="confirmPassword" className="mb-0">
                                    <Form.Label className="small" column='sm'>Confirmar Contraseña</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder="Confirmar contraseña"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                    />
                                </Form.Group>
                            </div>

                            <div className="d-grid gap-2">
                                <Button type="submit" variant="primary" size="lg">
                                    Actualizar
                                </Button>
                            </div>
                            {loadingUpdateProfile && <Loader />}
                        </Form>
                    </Card.Body>
                </Card>
            </Col>
            </Row>
        </>
    );
};

export default ProfileScreen;
